import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { Button, UploadFilesButton } from "nlib/ui";
import { getTextsData } from "selectors/texts";
import { useDispatch, useSelector } from "react-redux";
import DocumentFileTypes from "const/DocumentFileTypes";
import FileTypedIcon from "nlib/common/FileTypedIcon";
import Files from "utils/Files";
import MainApiActions from "actions/MainApiActions";
import React, { useCallback, useState } from "react";
import TransactionsActions from "actions/TransactionsActions";
import UiActions from "actions/UiActions";
import classNames from "classnames";
import useShowCommonModal from "hooks/useShowCommonModal";

const Attachment = (props) => {
  const {
    disabled,
    className,
    documentId,
    transactionId,
    attachmentId,
    attachmentName,
    attachmentKey,
    allowDelete = true
  } = props;

  const dispatch = useDispatch();

  const { uiTexts, messages } = useSelector(getTextsData);

  const showCommonModal = useShowCommonModal();

  const [fetching, setFetching] = useState(false);

  const handleFileChange = useCallback(async([file]) => {
    if (!file) return;
    setFetching(true);
    await dispatch(TransactionsActions.addAttachment(transactionId, file));
    setFetching(false);
  }, [dispatch, transactionId]);

  const handlePreviewClick = useCallback(async() => {
    setFetching(true);

    const extension = (attachmentName || "").split(".").pop().toLowerCase();

    const foundType = Object.values(DocumentFileTypes).find(({ extensions }) => extensions.includes(`.${extension}`));

    const imageType = foundType?.mimeType?.startsWith("image/");

    if (imageType) {
      dispatch(UiActions.showModalImages([""]));
    }

    const response = await dispatch(MainApiActions.fetchAttachmentUrl(
      { key: attachmentKey, originalName: attachmentName }, false, true
    ));

    if (response) {
      if (imageType) {
        dispatch(UiActions.showModalImages([response]));
      } else {
        Files.downloadContent(response);
      }
    }
    setFetching(false);
  }, [attachmentKey, attachmentName, dispatch]);

  const handleDetachClick = useCallback(async() => {
    setFetching(true);

    const result = await showCommonModal({
      text: messages.attachmentDeleteConfirm,
      confirm: true,
      okButtonText: uiTexts.delete
    });

    if (result) {
      await dispatch(TransactionsActions.removeAttachment(transactionId, attachmentId));
    }
    setFetching(false);
  }, [dispatch, showCommonModal, transactionId, attachmentId, messages, uiTexts]);

  const handleButtonClick = useCallback(() => {
    showCommonModal({ text: messages.unmatchToAttach });
  }, [showCommonModal, messages]);

  if (attachmentId) {
    return (
      <div className={classNames(Css.attachment, className)} disabled={fetching}>
        <div className={Css.icon} onClick={handlePreviewClick}>
          <FileTypedIcon className={Css.icon} fileName={attachmentName} />
        </div>
        {allowDelete && !disabled && (
          <div className={Css.action} onClick={handleDetachClick}>{uiTexts.deleteAttachment}</div>
        )}
      </div>
    );
  }
  if (documentId) {
    return (
      <div className={classNames(Css.attachment, className)}>
        <Button
          outline
          disabled={disabled}
          icon={Icons.File}
          onClick={handleButtonClick}>
          {uiTexts.addAttachment}
        </Button>
      </div>
    );
  }

  return (
    <div className={classNames(Css.attachment, className)}>
      <UploadFilesButton
        outline
        loading={fetching}
        multiple={false}
        icon={Icons.File}
        onChange={handleFileChange}>
        {uiTexts.addAttachment}
      </UploadFilesButton>
    </div>
  );
};

export default React.memo(Attachment);
